<template>
  <div class="home">
    <!-- <div class="title">
      欢迎！代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！
    </div> -->
    <div class="phone">
      <div>感谢您的关注！代账公司智能OA系统</div>
      <div>功能介绍：</div>
      <div class="desc">1.支持多人协同作业</div>
      <div class="desc">2.手机端、PC端同步</div>
      <div class="desc">3.客户资料上传后随时可查</div>
      <div class="desc">4.收款登记功能（太好用了）</div>
      <div class="desc">5.工商案件任务分配、定时完成</div>
      <div class="desc">6.员工绩效统计</div>
      <div>联系客服免费开通（微信号：A15102020）</div>
      <div>工作时间8:30~17:30</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      userInfo: {},
      qrcode: require('../assets/img/wechat-qrcode.jpeg')
    }
  },
  methods: {
    // 查询网吧数量
    queryIndexBar() {
      const params = {}
      this.areaLoading = true
      this.$get('/InternetBarManage/index/queryIndexBar', params)
        .then(response => {
          this.areaLoading = false
          if (response.code === 200) {
            this.areaBar = response.result.areaBar
            const areas = []
            const totals = []
            for (let i = 0; i < this.areaBar.length; i++) {
              areas.push(this.areaBar[i].areaName)
              totals.push(this.areaBar[i].barTotal)
            }
            this.$set(this.options.xAxis[0], 'data', areas)
            this.$set(this.options.series[0], 'data', totals)
            this.barTotal = response.result.barTotal
            this.waitTotal = response.result.waitTotal
          } else {
            this.$root.$children[0].vueAlert({ message: response.message, type: 'error' })
          }
        })
        .catch(err => {
          this.areaLoading = false
          console.log(err)
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
        })
    },
    // 查询在线人数，及网吧在线人数排名列表
    queryIndexOnline() {
      const params = {}
      this.onlineLoading = true
      this.$get('/InternetBarManage/index/queryIndexOnline', params)
        .then(response => {
          this.onlineLoading = false
          if (response.code === 200) {
            const onlineVO = response.result.onlineVO
            this.onlineVO = onlineVO.slice(0, 6)
          } else {
            this.$root.$children[0].vueAlert({ message: response.message, type: 'error' })
          }
        })
        .catch(err => {
          this.onlineLoading = false
          console.log(err)
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
        })
    }
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.home {
  min-height: 84vh;
  padding: 4vh 2vw 0;
  .title {
    display: flex;
    align-items: center;
    // 4个标题共用
    height: auto;
    line-height: 5vh;
    margin: 10px auto 20px;
    font-size: 1.25vw;
    font-weight: bold;
    text-align: left;
  }
  .phone {
    display: flex;
    flex-direction: column;
    height: auto;
    line-height: 5vh;
    padding-left: 5vw;
    margin: 10px auto 20px;
    font-size: 1.25vw;
    font-weight: bold;
    text-align: left;
    .desc {
      padding-left: 2.5vw;
    }
  }
  .qrcode {
    max-width: 25vw;
    margin-left: 2vw;
  }
}
</style>
